export const BANK_ACCOUNT_TYPE = [
  { label: "Savings", value: "SB" },
  { label: "Current", value: "CB" },
];

export const DISTRIBUTOR_BANK_ACCOUNT_TYPE_OPTIONS = [
  { label: "Savings", value: "savings" },
  { label: "Current", value: "current" },
];

export const NOMINEE_RELATIONSHIP = [
  { label: "Spouse", value: "spouse" },
  { label: "Father", value: "father" },
  { label: "Mother", value: "mother" },
  { label: "Son", value: "son" },
  { label: "Daughter", value: "daughter" },
  { label: "Son-in-Law", value: "son_in_law" },
  { label: "Daughter-in-Law", value: "daughter_in_law" },
  { label: "Grandson", value: "grand_son" },
  { label: "Granddaughter", value: "grand_daughter" },
  { label: "Aunt", value: "aunt" },
  { label: "Brother-in-Law", value: "brother_in_law" },
  { label: "Brother", value: "brother" },
  { label: "Father-in-Law", value: "father_in_law" },
  { label: "Grandfather", value: "grand_father" },
  { label: "Grandmother", value: "grand_mother" },
  { label: "Mother-in-Law", value: "mother_in_law" },
  { label: "Nephew", value: "nephew" },
  { label: "Niece", value: "niece" },
  { label: "Sister", value: "sister" },
  { label: "Sister-in-Law", value: "sister_in_law" },
  { label: "Uncle", value: "uncle" },
  { label: "Others", value: "others" },
];

export const GENDER = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "transgender" },
];

export const OCCUPATION = [
  { label: "Business", value: "business" },
  { label: "Services", value: "services" },
  { label: "Professional", value: "professional" },
  { label: "Agriculture", value: "agriculture" },
  { label: "Retired", value: "retired" },
  { label: "Housewife", value: "housewife" },
  { label: "Student", value: "student" },
  { label: "Others", value: "others" },
];

export const INCOME_RANGE = [
  { label: "<1L", value: "upto_1lakh" },
  { label: "1L-5L", value: "above_1lakh_upto_5lakh" },
  { label: "5L-10L", value: "above_5lakh_upto_10lakh" },
  { label: "10L-25L", value: "above_10lakh_upto_25lakh" },
  { label: "25L-1Cr", value: "above_25lakh_upto_1cr" },
  { label: ">1Cr", value: "above_1cr" },
];

export const SOURCE_OF_WEALTH = [
  { label: "Salary", value: "salary" },
  { label: "Business", value: "business" },
  { label: "Gift", value: "gift" },
  { label: "Ancestral property", value: "ancestral_property" },
  { label: "Rental income", value: "rental_income" },
  { label: "Prize money", value: "prize_money" },
  { label: "Royalty", value: "royalty" },
  { label: "Others", value: "others" },
];

export const HOLDING_TYPE = [
  { label: "Single", value: "single" },
  { label: "Joint", value: "joint" },
];

export const PEP_STATUS = [
  { label: "Not applicable", value: "not_applicable" },
  { label: "I'm exposed", value: "pep_exposed" },
  { label: "I'm related", value: "pep_related" },
];

export const BELONGS_TO = [
  { label: "Self", value: "self" },
  { label: "Spouse", value: "spouse" },
  { label: "Dependent Children", value: "dependent_children" },
  { label: "Dependent Siblings", value: "dependent_siblings" },
  { label: "Dependent Parents", value: "dependent_parents" },
  { label: "Guardian", value: "guardian" },
  { label: "PMS", value: "pms" },
  { label: "Custodian", value: "custodian" },
  { label: "POA", value: "poa" },
];

export const DEFAULT_DOB_DATE = "1990-01-01";

export const IDENTITY_TYPE_CHOICES = [
  { label: "PAN", value: "1" },
  { label: "Aadhaar", value: "2" },
  { label: "License", value: "3" },
  { label: "Passport", value: "4" },
];

export function getIdentityNumberPlaceholder(identityType: string) {
  if (identityType === "1") {
    return "Enter PAN number";
  }

  if (identityType === "2") {
    return "Enter Aadhaar number (Last 4 digits)";
  }

  if (identityType === "3") {
    return "Enter Driving License number";
  }

  if (identityType === "4") {
    return "Enter Passport number";
  }

  return "Enter identity number";
}
